import React from 'react';

import ConnectedAuthNotification from '../connectedComponents/AuthNotification';

import './LoginSplitContainer.scss';

const LoginSplitContainer = ({ leftSection, rightSection }) => (
    <div className="authentication__login">
        <ConnectedAuthNotification />

        <div className="authentication__login-options">
            <div
                className="authentication__login-options__left"
                data-automation="social-login-section"
            >
                {leftSection}
            </div>

            <div
                className="authentication__login-options__right"
                data-automation="eventbrite-login-section"
            >
                {rightSection}
            </div>
        </div>
    </div>
);

export default LoginSplitContainer;
